/**
 * Tunisian dinar.
 */
export var TND = {
  code: 'TND',
  base: 10,
  exponent: 3
};